import { FC, ReactNode } from 'react';

import { Container, ContainerProps, rem } from '@bonusly/design-system';

export const ADMIN_PAGE_WIDTHS = {
	narrow: rem(720),
	standard: rem(960),
	wide: rem(1200),
	full: '100%',
} as const;

type AdminPageWidth = keyof typeof ADMIN_PAGE_WIDTHS;

interface AdminPageContainerProps extends ContainerProps {
	children: ReactNode;
	width?: AdminPageWidth;
}

export const AdminPageContainer: FC<AdminPageContainerProps> = ({ children, width = 'standard', ...props }) => (
	<Container maxW={ADMIN_PAGE_WIDTHS[width]} mx={0} px={10} py={8} {...props}>
		{children}
	</Container>
);
